"use strict";

svg4everybody();

var parseDate = function(timestamp) {
  var _date = new Date();

  _date.setTime(timestamp * 1000);

  var hours = _date.getHours(),
    minutes = _date.getMinutes(),
    day = _date.getDate(),
    month = _date.getMonth(),
    year = _date.getFullYear();
  return day + "." + month + "." + year;
}

;(function() {

  // $.ajaxSetup({ data: { csrf_vh_name:$.cookie("csrf_vh_cookie") } });

  $('body').scrollspy({ target: '#navbarSupportedContent' });

  function mainRedirect() {
    window.location.href = "/";
  }

  if ( $('.page-404').length ) {
    setTimeout(mainRedirect, 4000);
  }

  if ( $('[data-inputmask]').length > 0) {
    $("[data-inputmask]").inputmask("+7(999)999-99-99");
  }

  if ( $('.alert-success').length > 0) {
    setTimeout(function(){
      $('.alert-success').fadeOut('slow');
    }, 7000);
  }

  // $('.navbar-nav>li>a').on('click', function(){
  //   $('.navbar-collapse').collapse('hide');
  // });

  function parallaxScroll(){
    var
      $navbar = $('.nav-main'),
      _scrolled = $(window).scrollTop(),
      _win_h = $(window).height(),
      _win_w = $(window).width();

    if (_scrolled > (_win_h - 3) ) {
      $navbar.addClass('_line');
    } else {
      $navbar.removeClass('_line');
    }
  }

  window.addEventListener('scroll', function(e){
    parallaxScroll();
  });

  // $('#carousel-inner').slick({
  //   autoplay: true,
  //   autoplaySpeed: 4000,
  //   arrows: true,
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   fade: true,
  //   centerMode: true,
  //   variableWidth: false,
  //   cssEase: 'linear',
  //   responsive: [
  //   {
  //     breakpoint: 769,
  //     settings: {
  //       autoplay: true,
  //       // dots: true,
  //       dots: false,
  //       arrows: true
  //     }
  //   },
  //   {
  //     breakpoint: 1023,
  //     settings: {
  //       // slidesToShow: 50,
  //       autoplay: true,
  //       dots: false,
  //       // dots: true,
  //       arrows: false
  //     }
  //   },
  //   ]
  // });

  $( '.dropdown-menu .dropdown-toggle' ).on('click', function() {
    var
      $el = $(this),
      $parent = $el.offsetParent(".dropdown-menu");

    if (!$el.next().hasClass("show")) {
      $el.parents('.dropdown-menu').first().find(".show").removeClass("show");
    }
    $el.next(".dropdown-menu").toggleClass("show").parent("li").toggleClass("show");

    $el.parents("li.nav-item.dropdown.show").on("hidden.bs.dropdown", function () {
      $(".dropdown-menu .show").removeClass("show");
    });

    if (!$parent.parent().hasClass("navbar-nav")) {
      $el.next()
      .css({
        "top": $el[0].offsetTop,
        "left": $parent.outerWidth()
      });
    }

    return false;
  });

  $('[href="'+ document.location.href +'"]').parents('.dropdown').addClass('active');

  // ### NavBar Background
  // if($('.navbar').length > 0) {
  //   $.affix({
  //     target: '.navbar',
  //     offset: $('.header').offset().top,
  //   });
  // }

})();